<div class="form-container">
  <h2 class="heading-color fw-bold">Internship Application Form</h2>
  <p class="subtitle">
    Please fill in your details to apply for the internship.
  </p>

  <form [formGroup]="applicationForm" (ngSubmit)="submit()">
    <!-- Row 1 -->
    <div class="row">
      <div class="field">
        <label>Email<span class="text-danger">*</span></label>
        <input type="email" class="form-control" formControlName="email" placeholder="Enter your email" />
        <span class="error" *ngIf="submitted && applicationForm.get('email')?.invalid">
          Please Enter your Email
        </span>
      </div>

      <div class="field">
        <label>Name <span class="text-danger">*</span></label>
        <input type="text" formControlName="name" class="form-control" placeholder="Enter your full name" />
        <span class="error" *ngIf="submitted && applicationForm.get('name')?.errors">
          <span *ngIf="applicationForm.get('name')?.errors?.['required']">
            Please Enter Your Name
          </span>

          <span *ngIf="applicationForm.get('name')?.errors?.['minlength']">
            Enter at least 3 characters
          </span>
        </span>


      </div>
    </div>

    <!-- Row 2 -->
    <div class="row">
      <div class="field">
        <label>Address<span class="text-danger">*</span></label>
        <input type="text" formControlName="address" class="form-control" placeholder="Enter your full address" />
        <span class="error" *ngIf="submitted && applicationForm.get('address')?.errors">
          <span *ngIf="applicationForm.get('address')?.errors?.['required']">
            Please Enter Your Address
          </span>

          <span *ngIf="applicationForm.get('address')?.errors?.['minlength']">
            Enter at least 3 characters
          </span>
        </span>

      </div>

      <div class="field">
        <label>Phone Number<span class="text-danger">*</span></label>
        <input type="text" formControlName="phone" class="form-control" placeholder="Enter your phone number" />
        <span class="error" *ngIf="submitted && applicationForm.get('phone')?.errors">
          Phone number must be exactly 10 digits and contain no spaces
        </span>

      </div>
    </div>

    <!-- Row 3 -->
    <div class="row">
      <div class="field">
        <label>College Name<span class="text-danger">*</span></label>
        <input type="text" class="form-control" formControlName="college" placeholder="e.g. Stanford University, CA" />
        <span class="error" *ngIf="submitted && applicationForm.get('college')?.errors">
          <span *ngIf="applicationForm.get('college')?.errors?.['required']">
            Please Enter Your College
          </span>

          <span *ngIf="applicationForm.get('college')?.errors?.['minlength']">
            Enter at least 3 characters
          </span>
        </span>

      </div>

      <div class="field" [class.error]="
          submitted && applicationForm.get('qualification')?.invalid
        ">
        <label>Qualification <span class="text-danger">*</span></label>

        <select formControlName="qualification" class="form-select"
          [class.is-invalid]="submitted && applicationForm.get('qualification')?.invalid">
          <option value="" disabled selected hidden>Select Qualification</option>
          <option value="B.Tech">B.Tech</option>
          <option value="M.Tech">M.Tech</option>
          <option value="Degree">Degree</option>
          <option value="Other">Other</option>
        </select>

        <span class="error" *ngIf="submitted && applicationForm.get('qualification')?.invalid">
          Please select a qualification
        </span>

        <!-- Show "Other" input field dynamically -->
        <div *ngIf="applicationForm.get('qualification')?.value === 'Other'" class="mt-2">
          <label>Please specify the qualification <span class="text-danger">*</span></label>
          <input type="text" class="form-control" formControlName="qualification_other"
            placeholder="Enter your qualification" />

          <span class="error" *ngIf="submitted && applicationForm.get('qualification_other')?.invalid">
            Please specify your qualification
          </span>
        </div>


      </div>
    </div>

    <!-- Row 4 -->
    <div class="row">
      <div class="field">
        <label>Area of Study<span class="text-danger">*</span></label>
        <input type="text" formControlName="major" class="form-control" placeholder="e.g. CSE – AI & ML" />

        <span class="error" *ngIf="submitted && applicationForm.get('major')?.errors">
          <span *ngIf="applicationForm.get('major')?.errors?.['required']">
            Please Enter Your Branch
          </span>

          <span *ngIf="applicationForm.get('major')?.errors?.['minlength']">
            Enter at least 3 characters
          </span>
        </span>

      </div>

      <div class="field" [class.error]="
          submitted && applicationForm.get('graduationYear')?.invalid
        ">
        <label>Graduation Year <span class="text-danger">*</span></label>

        <select formControlName="graduationYear" class="form-select">

          <!-- Placeholder (not selectable again) -->
          <option value="" disabled selected hidden>
            Select Graduation Year
          </option>

          <!-- Actual options -->
          <option value="2021">2021</option>
          <option value="2022">2022</option>
          <option value="2023">2023</option>
          <option value="2024">2024</option>
          <option value="2025">2025</option>
          <option value="2026">2026</option>
          <option value="2027">2027</option>
          <option value="2028">2028</option>
          <option value="2029">2029</option>
          <option value="2030">2030</option>

        </select>

        <span class="error" *ngIf="submitted && applicationForm.get('graduationYear')?.invalid">
          Enter your graduation year
        </span>


      </div>
    </div>

    <!-- Textarea -->
    <div class="field full">
      <label>Why are you interested in this internship?<span class="text-danger">*</span></label>
      <textarea formControlName="interestReason" class="form-control"
        placeholder="Tell us what excites you about this opportunity..."></textarea>
      <span class="error" *ngIf="submitted && applicationForm.get('interestReason')?.errors">
        <span *ngIf="applicationForm.get('interestReason')?.errors?.['required']">
          Please Enter Your Opinion
        </span>

        <span *ngIf="applicationForm.get('interestReason')?.errors?.['minlength']">
          Enter at least 3 characters
        </span>
      </span>

    </div>

    <div class="field full">
      <label>Additional comments</label>
      <textarea formControlName="comments" class="form-control"
        placeholder="Anything else you'd like to share?"></textarea>
    </div>

    <!-- Row 4 -->
    <div class="row">
      <div class="field">
        <label>LinkedIn URL</label>
        <input type="text" class="form-control" formControlName="linkedin"
          placeholder="https://www.linkedin.com/in/yourprofile" />
      </div>

<div class="field">

  <label for="resume">
    Upload Resume (PDF only)
  </label>

  <input
    id="resume"
    type="file"
    #resumeInput
    class="form-control"
    accept="application/pdf,.pdf"
    (change)="onResumeUpload($event)"
  />


  <!-- Uploading -->
  <div
    class="text-primary mt-2"
    *ngIf="resumeUploading"
  >
    Uploading resume...
  </div>


  <!-- Upload Error -->
  <div
    class="text-danger mt-2"
    *ngIf="resumeError"
  >
    {{ resumeError }}
  </div>


  <!-- Required Error -->
  <span
    class="error"
    *ngIf="
      submitted &&
      applicationForm.get('resume_url')?.invalid &&
      !resumeUploading
    "
  >
    Please upload your resume
  </span>


  <!-- Uploaded File -->
  <div
    class="text-success mt-2"
    *ngIf="
      applicationForm.get('resume_url')?.value &&
      !resumeUploading
    "
  >
    Resume uploaded successfully
  </div>

</div>
    </div>

    <!-- Radio -->
    <div class="field full">
      <label>Are you Interested in Programming or Non-Programming?<span class="text-danger">*</span></label>

      <div class="radio-group">
        <label>
          <input type="radio" formControlName="interestType" value="Programming" />
          Programming
        </label>

        <label>
          <input type="radio" formControlName="interestType" value="Non-Programming" />
          Non-Programming
        </label>
      </div>

      <!-- Validation Message -->
      <span class="error" *ngIf="submitted && applicationForm.get('interestType')?.invalid">
        Please Select Your Interest
      </span>
    </div>

    <!-- Checkbox -->
    <div class="checkbox-field">
      <label class="checkbox-label">
        <input type="checkbox" formControlName="terms" />

        <span class="checkbox-text">
          I accept the
          <a routerLink="/terms-and-conditions" href="/terms-and-conditions" target="_blank" rel="noopener">
            Terms & Conditions
          </a>
          <span class="text-danger">*</span>
        </span>
      </label>

      <!-- Error message MUST be outside label -->
      <span class="error checkbox-error" *ngIf="submitted && applicationForm.get('terms')?.invalid">
        You must accept the Terms & Conditions
      </span>
    </div>



    <button type="submit" class="submit-btn mx-auto d-block">
      Submit Application
    </button>

  </form>
</div>

<!-- Success / Error Modal -->
<!-- BOOTSTRAP POPUP MODAL -->
<!-- SUCCESS / ERROR MODAL -->
<div class="modal fade" id="responseModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content text-center border-0 shadow-lg p-4">

      <!-- Icon -->
      <!-- Icon -->
      <div class="mb-4">
        <div class="d-inline-flex align-items-center justify-content-center rounded-circle" [ngClass]="{
      'success-circle': modalType === 'success',
      'error-circle': modalType === 'error'
    }">
          <i class="bi" [ngClass]="{
        'bi-check-lg success-icon': modalType === 'success',
        'bi-x-lg error-icon': modalType === 'error'
      }"></i>
        </div>
      </div>


      <!-- Title -->
      <h3 class="fw-bold mb-3">
        {{ modalTitle }}
      </h3>

      <!-- Message -->
      <p class="text-muted mb-4 px-3">
        {{ modalMessage }}
      </p>

      <!-- Button -->
      <button type="button" class="btn " data-bs-dismiss="modal">
        OK
      </button>


    </div>